// src/pages/TodoList.jsx
import React, { useEffect, useState } from 'react';
import { Button, Dropdown, DropdownButton, Form, Modal } from 'react-bootstrap';
import './Todo.css';
import { addTodoAction, getTodolistAction } from '../../actions/todo';
import TodoModal from './TodoModal';
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import Header from '../../components/header/header';
import { Controller, useForm, useWatch } from 'react-hook-form';
import { getUserListingAction } from '../../actions/user';
import ViewDetails from './ViewDetails';

const USER_ID = '69049d9d286471ea09e0c261'; // use your actual user id

export default function TodoList() {
  const { control } = useForm();
  const dispatch = useDispatch();

  const [modalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [activePage, setActivePage] = useState(0);
  const [selectedUser, setSelectedUser] = useState({});
  const [search, setSearch] = useState('');
  const [show, setShow] = useState(false);         // view details modal
  const [pageItem, setPageItem] = useState(null);  // selected todo for detail

  const { userList } = useSelector((state) => state.user);
  const { todoListData, todoCount } = useSelector((state) => state.todo);

  const limit = useWatch({ control, name: 'limit' });

  const handleViewModal = (item) => {
    setPageItem(item);
    setShow(true);
  };

  const sortByStatus = (data) => {
    setSelectedUser(data);
    setPage(1);
    setActivePage(0);
  };

  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setActivePage(selectedPage);
    setPage(selectedPage + 1);
  };

  const load = async () => {
    await dispatch(getTodolistAction(page, limit, search, selectedUser));
    dispatch(getUserListingAction(1, 2000));
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search, selectedUser]);

  const handleAddTodo = async (data, selectedUser) => {
    await dispatch(addTodoAction(data, selectedUser));
    load();
  };

  return (
    <>
      <Header title="Todo" />

      <div className="container-fluid py-4">
        <div className="row">
          <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12 mb-2">
            <div className="card planList">
              <div className="card-header d-flex flex-column flex-md-row align-items-md-center justify-content-between">
                {/* Search */}
                <div className="searchbar mb-3 mb-md-0">
                  <input
                    type="search"
                    placeholder="Search plan"
                    name="search"
                    autoComplete="off"
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value.trimLeft());
                    }}
                  />
                  <img src="assets/img/searchIcon.svg" alt="" />
                </div>

                {/* Filter + Add button */}
                <div className="filter d-flex flex-column flex-md-row align-items-md-center gap-2">
                  <div className="dropdownButton">
                    <img src="assets/img/downArrow.svg" alt="" />
                    <DropdownButton
                      id="dropdown-basic-button"
                      title={
                        selectedUser?.first_name
                          ? `${selectedUser?.first_name} ${selectedUser?.last_name}`
                          : 'Search by user'
                      }
                    >
                      {userList.map((item, index) => (
                        <Dropdown.Item
                          key={index}
                          onClick={() => sortByStatus(item)}
                        >
                          {item.first_name + ' ' + item.last_name || '-'}
                        </Dropdown.Item>
                      ))}
                    </DropdownButton>
                  </div>
                  <div className="addButton">
                    <button
                      onClick={() => setModalOpen(true)}
                      className="customAddButton customTodoAddButton"
                    >
                      Add new todo
                    </button>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <div className="card-body table-store payments p-3">
                  {/* Desktop / Tablet header row */}
                  <div className="row mt-3 font-weight-bold text-dark">
                    <div className="col-md-4 col-lg-4">Title</div>
                    <div className="col-md-4 col-lg-4">User</div>
                    <div className="col-md-2 col-lg-2">Status</div>
                    <div className="col-md-2 col-lg-2">Action</div>
                  </div>

                  {todoListData && todoListData.length > 0 ? (
                    todoListData.map((item, index) => (
                      <div
                        key={index}
                        className="row mt-3 todo-row align-items-start align-items-md-center"
                      >
                        {/* Title */}
                        <div className="col-md-4 col-lg-4 mb-2 mb-md-0">
                          <h6 className="profile-text text-sm">
                            {item?.title}
                          </h6>
                        </div>

                        {/* User */}
                        <div className="col-12 col-md-4 col-lg-4 mb-2 mb-md-0">
                          <h6 className="profile-text text-sm">
                            {item?.user?.first_name + ' ' + item?.user?.last_name}
                            <br />
                            {item?.user?.email}
                          </h6>
                        </div>

                        {/* Status */}
                        <div className="col-6 col-md-2 col-lg-2 mb-2 mb-md-0">
                          <h6 className="profile-text text-sm Statusbtn">
                            {item?.status?.toUpperCase() || '-'}
                          </h6>
                        </div>

                        {/* Action */}
                        <div className="col-6 col-md-2 col-lg-2">
                          {item?.status === 'completed' && (
                            <div className="d-flex justify-content-md-start justify-content-end">
                              <button
                                onClick={() => handleViewModal(item)}
                                className="btn btn-sm view-button m-0"
                              >
                                View details
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="d-flex pt-3">
                      <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-0 text-sm table-heading text-center">
                          No todo found
                        </h6>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Bottom controls */}
              <div className="tableBottom tableBottompadding d-flex flex-column flex-md-row align-items-md-center justify-content-between">
                <div className="filterButton mb-2 mb-md-0">
                  <div className="dropdownButton">
                    <Controller
                      name="limit"
                      control={control}
                      defaultValue={10}
                      render={({ field }) => (
                        <Form.Select
                          {...field}
                          className="select-border"
                          placeholder="10"
                        >
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </Form.Select>
                      )}
                    />
                  </div>
                </div>

                <div>
                  {todoCount > 1 && (
                    <div className="pagination-section">
                      <ReactPaginate
                        previousLabel={'Prev'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={todoCount}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={3}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        forcePage={activePage}
                      />
                    </div>
                  )}
                </div>
              </div>

              <TodoModal
                show={modalOpen}
                onHide={() => setModalOpen(false)}
                onSubmit={handleAddTodo}
                userId={USER_ID}
              />

              <ViewDetails show={show} onClose={() => setShow(false)} pageItem={pageItem}/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
